import { createContext, useContext } from 'react';
export const UserLevelSettingsContext = createContext(undefined);
export const useUserLevelSettings = () => {
    const context = useContext(UserLevelSettingsContext);
    if (!context) {
        throw new Error('useUserLevelSettings needs to be wrapped by UserLevelSettingsProvider');
    }
    return context;
};
